import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from "rxjs/Subject";
import { Http, Headers, RequestOptions } from '@angular/http';
import { AuthService } from './auth.service';
import 'rxjs/add/operator/map';
import * as Enums from './Enums/index';
import { environment } from '../../environments/environment';


@Injectable()
export class GlobalService {
  domain = this.authService.domain;
  images_domain=environment.images_domain;;
  sidebar = new Subject<boolean>();
  accounts = new Subject<any[]>();
  roles = new Subject<any[]>();

  sideBar$ = this.sidebar.asObservable();
  accounts$ = this.accounts.asObservable();
  roles$ = this.roles.asObservable();

  enumHelpers = Enums;
  totalItems = 10;//いろんなページの1ページ内件数
  totalItems_studentList = 100;//受講者リストだけこれを採用するよう変更

  getMainteInfoInterval=60*1000;//メンテナンス情報取得のインターバル

  //roleの表示名を変える(UI上のみ)
  roleFaceName={
    'グロービス事務局':'グロービス事務局（Admin）',
    'お客様事務局':'お客様事務局',
    '受講生向け':'受講生向け',//変えないほうがいい（なんか文字列判定しているところがあった気がする）
    'コースフォーマット・エディター':'グロービス事務局（コースフォーマット・エディター）',
    'オペレーター':'グロービス事務局（オペレーション担当者）',
  };

  constructor(
    private http: Http,
    private authService: AuthService,
  ) { 
  }
  //---------------------------------- Getting API data with subscribe ---------------------------------------------------
  //Getting Global Data API

  getAccountAPI(){
    return this.http.get( this.domain + 'account' , this.authService.options).map(res => res.json());      
  }

  getRoleAPI(){
    return this.http.get( this.domain + 'role' , this.authService.options).map(res => res.json());      
  }

  getMaintenanceAPI(){
    return this.http.get( this.domain + 'account/maintenance' , this.authService.options).map(res => res.json());
  }

  // ---------------------------------- Process subcribe API data --------------------------------------------------------
  // Process Login API data with call back 

  getAccountProcess(){
    this.getAccountAPI().subscribe( data => {
      this.accounts.next(data);
    },
    err => {
      console.log(err);
    })
  }

  getRoleProcess(){
    this.getRoleAPI().subscribe( data => {
      this.roles.next(data);
    },
    err => {
      console.log(err);
    })
  }

  update(active: boolean){
    this.sidebar.next(active);
  }

  // pass image name
  getImageUrl(imgFileName) {
    //S3に変更したので変更

    let imgUrl = this.images_domain;//this.domain + 'question/image/';

    if (imgFileName) {
      imgUrl = imgUrl + imgFileName;//imgUrl + imgFileName.substring(imgFileName.lastIndexOf('/') + 1);
    }
    return imgUrl;
  }

  // when detected press browser back btn, set localstorage tmp search
  setTmpKey(data) {
    if (data.url.indexOf('dashboard') >= 0) {
      let searchKey = localStorage.getItem('search') || "";
      localStorage.setItem('backBtn', 'true');
      localStorage.setItem('tmpSearch', searchKey);
    }
  }

  // get footer pattern by answered data
  getFooterPattern(data) {
    const questionHelpers = new this.enumHelpers.QuestionType();
    let feedbackText = "";
    let choice = 0;

    if (data.question.type == questionHelpers.getValue('essay')) {
        feedbackText = data.question.feedback_pattern_1;
    } else {
      choice = this._setChoice(data);
      switch(choice) {
        case 0: {
          feedbackText = this._setFeedbackText(data);
          break;
        }
        case 1: {
          feedbackText = data.question.feedback_pattern_1;
          break;
        }
        case 2: {
          feedbackText = data.question.feedback_pattern_2;
          break;
        }
        case 3: {
          feedbackText = data.question.feedback_pattern_3;
          break;
        }
        case 4: {
          feedbackText = data.question.feedback_pattern_4;
          break;
        }
        default: {
          break; 
        }
      }
    }

    return feedbackText;
  }

  // get footer pattern by answered data
  getFooterPattern_under(data) {
    const questionHelpers = new this.enumHelpers.QuestionType();
    let feedbackText = "";
    let choice = 0;

    if (data.question.type == questionHelpers.getValue('essay')) {
        feedbackText = data.question.feedback_pattern_1_under;
    } else {
      choice = this._setChoice(data);
      switch(choice) {
        case 0: {
          feedbackText = this._setFeedbackText_under(data);
          break;
        }
        case 1: {
          feedbackText = data.question.feedback_pattern_1_under;
          break;
        }
        case 2: {
          feedbackText = data.question.feedback_pattern_2_under;
          break;
        }
        case 3: {
          feedbackText = data.question.feedback_pattern_3_under;
          break;
        }
        case 4: {
          feedbackText = data.question.feedback_pattern_4_under;
          break;
        }
        default: {
          break; 
        }
      }
    }

    return feedbackText;
  }

  // check data have choice or no, 
  // and data from "problem" page dont have choice
  _setChoice(data) {
    // data return from [student] feedback page and [customer] student details page is different object;
    let result = 0;
    if (data.choice) {
      result = data.choice;
    } else if (data.answer) {
      result = data.answer.choice ? data.answer.choice : 0;
    } else {
      result = 0;
    }
    return result;
  }

  // set feedback text if the choice == 0
  // problem page -> comment modal want to show all feedback pattern
  _setFeedbackText(data) {
    let result = "";
    if (data.question.feedback_pattern_1 !== '') {
      result += data.question.feedback_pattern_1 + '\n';
    }
    if (data.question.feedback_pattern_2 !== '') {
      result += data.question.feedback_pattern_2 + '\n';
    }
    if (data.question.feedback_pattern_3 !== '') {
      result += data.question.feedback_pattern_3 + '\n';
    }
    if (data.question.feedback_pattern_4 !== '') {
      result += data.question.feedback_pattern_4;
    }

    return result;
  }
  //under
  _setFeedbackText_under(data) {
    let result = "";
    if (data.question.feedback_pattern_1_under !== '') {
      result += data.question.feedback_pattern_1_under + '\n';
    }
    if (data.question.feedback_pattern_2 !== '') {
      result += data.question.feedback_pattern_2_under + '\n';
    }
    if (data.question.feedback_pattern_3 !== '') {
      result += data.question.feedback_pattern_3_under + '\n';
    }
    if (data.question.feedback_pattern_4 !== '') {
      result += data.question.feedback_pattern_4_under;
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/global.service.ts